import { NgModule } from '@angular/core'
import { VideoListItemComponent } from './video-list-item.component'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { SharedModule } from '../../../../shared/shared.module'
import { IsoStringToDatePipeModule } from '../../../iso-string-to-date-pipe/iso-string-to-date-pipe.module'

@NgModule({
  imports: [CommonModule, RouterModule, SharedModule, IsoStringToDatePipeModule],
  exports: [VideoListItemComponent],
  declarations: [VideoListItemComponent]
})
export class VideoListItemModule {}
